export const abbreviations = [
    {
        pattern: /Товарищество с ограниченной ответственностью/gi,
        substring: 'ТОО'
    },
    {
        pattern: /Акционнерное общество/gi,
        substring: 'АО'
    }
]